import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class WeatherDebugView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isDailyState: true
        }
    }

    render() {
        return (
            <div style={{
                position: "absolute",
                maxHeight: "100%",
                maxWidth: "100%",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                margin: 0,
                overflow: "scroll",
                backgroundColor: "#FFF",
                color: "#000",
                padding: "30px 30px",
            }}>
                <div>
                    <b>Debug Weather app</b>
                </div>
                <div>
                    <p>
                        <b>General data</b>
                    </p>
                    <pre>
                        {JSON.stringify(this.props.general_data, null, 4)}
                    </pre>
                </div>
                <div>
                    <p>
                        <b>Current data</b>
                    </p>
                    <pre>
                        {JSON.stringify(this.props.current_data, null, 4)}
                    </pre>
                </div>
                <div>
                    <p>
                        <b>Daily data</b>
                    </p>
                    <pre>
                        {JSON.stringify(this.props.daily_data, null, 4)}
                    </pre>
                </div>
                <div>
                    <p>
                        <b>Hourly data</b>
                    </p>
                    <pre>
                        {JSON.stringify(this.props.hourly_data, null, 4)}
                    </pre>
                </div>
                <div>
                    <p>
                        <b>Original Server Response</b>
                    </p>
                    <pre>
                        {JSON.stringify(this.props.original_data, null, 4)}
                    </pre>
                </div>
            </div>
        )
    }
}

WeatherDebugView.propTypes = {
    original_data: PropTypes.any.isRequired,
    general_data: PropTypes.any.isRequired,
    current_data: PropTypes.any.isRequired,
    daily_data: PropTypes.any.isRequired,
    hourly_data: PropTypes.any.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/weather/weatherDebugView.js